<template>
  <div class="schedule">
    <my-study-nav></my-study-nav>
    <div class="content-right">
      <h2 class="top-title">课程日历表</h2>
      <!--<section class="category-wrapper">-->
        <!--<span class="tab-item active" @click="changeTab(1)">-->
          <!--课程记录-->
        <!--</span>-->
      <!--</section>-->
      <div class="calendar-wrapper">
        <calendar @changeDay="getDay" @changeToday="changeToday"></calendar>
      </div>
      <div class="list-wrapper">
        <!--<div class="list-title">-->
          <!--{{computeChoseDay}}-->
        <!--</div>-->
        <div class="list-item" v-for="(item,index) in list" v-if="list.length">
          <div class="item-top">
            <div class="time-wrapper">
              <p class="starttime">{{item.planstarttime.substring(11,16)}}</p>
              <p class="endtime">{{item.planendtime.substring(11,16)}}</p>
            </div>
            <div class="item-img-wrapper">
              <span class="item-img-icon" v-if="item.democlass==='0'">正式课</span>
              <img :src="imgprefix+item.lessonfaceimg" alt="课程图片" width="142" height="92">
            </div>
            <div class="class-content-wrapper">
              <p class="main-title">
                {{decodeURIComponent(item.lessonname)}}
                <span class="connect" @click="QueryTeacherContactInfo(item)">联系老师</span>
              </p>
              <p class="sub-title">
                [{{decodeURIComponent(item.classmodename)}}]
                {{decodeURIComponent(item.classname)}}</p>
            </div>
            <span v-if="item.statusflag==='1'" class="finish-icon"></span>
          </div>
          <div class="item-bottom">
            <div class="mulu-item">
              <section class="place">
                <span class="free-icon" v-if="item.democlass=='1'">试听</span>
              </section>
              <section class="mulu-name-wrapper" v-if="item.democlass=='0'">
                <p class="mulu-name">{{decodeURIComponent(item.catalogname)}}</p>
              </section>
              <div class="mulu-operate-wrapper">
                <button class="mulu-btn check" :class="{'show':item.show,'not-show':!item.show}"
                        @click="getCourseWare(item)">查看课件
                </button>
                <button class="mulu-btn review"
                        v-if="item.statusflag==='1'&&item.txtfilename!==''&&item.mp3filename!==''"
                        @click="reviewLive(item)">课程回看
                </button>
                <button class="mulu-btn live" @click="gotoLive(item)"
                        v-if="item.statusflag!='1'||isSameDay(returnServerToday,item.planstarttime.substring(0,10))">
                  进入上课
                </button>
              </div>
            </div>
            <div class="wareList-wrapper" v-if="item.show">
              <template v-if="!isEmpty(item.coursewarelist)">
                <div class="ware-item" v-for="(data,index3) in item.coursewarelist">
                  <div class="ware-img-wrapper">
                    <img :src="imgprefix+data.faceimg" alt="课件封面" width="84" height="60">
                  </div>
                  <p class="courseware-name">{{decodeURIComponent(data.coursewarename)}}</p>
                  <section class="courseware-btn-wrapper">
                    <button class="courseware-btn transparent" @click="previewWare(data)">预览</button>
                  </section>
                </div>
              </template>
              <section class="no-schedule-wrapper" v-else>
                <img class="empty-img" src="./empty.png" alt="无课件" width="68" height="68">
                <span class="no-schedule">暂无课件</span>
              </section>
            </div>
          </div>
        </div>
        <div class="no-result" v-if="isEmpty(list)">
          <img src="./noresult.png" alt="没有结果" width="290" height="164">
          <a href="/" class="noresult-link">~暂无待上的课程~</a>
        </div>
      </div>
    </div>
    <div class="newpop-mask" v-if="newShow">
      <div class="newpop">
        <h2 class="new-title">联系老师</h2>
        <img class='close'
             @click="newShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <template v-if="!isEmpty(teacherInfo)">
          <div class="row" v-if="teacherInfo.phone">
            联系电话：{{teacherInfo.phone}}
          </div>
          <div class="row" v-if="teacherInfo.wx">
            微信：{{classType == 1? teacherInfo.phone: teacherInfo.wx}}
          </div>
        </template>
      </div>
    </div>
    <div class="chantime-mask" v-if="changetimeShow">
      <div class="chantime">
        <p class="img-wrapper">
          <img class='close'
               @click="newShow=false;"
               src="./changetime-hint.png"
               alt="close"
               width="128"
               height="128">
        </p>
        <h2 class="chantime-title">全优在线提示！</h2>
        <p class="changetime-para">只有今天有课程才能进入直播间，如果无法进入直播间，可以联系老师修改上课时间到今天</p>
        <button class="changetime-btn" @click="changetimeShow=false">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import calendar from 'components/calendar/calendar'
  import MyStudyNav from 'components/mystudynav/MyStudyNav'
  import {isSameDay} from 'common/js/calendar.js'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        userinfo: (() => loadLocal('userinfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //切换tab
        index: 1,
        //-----------以下内容和课程表有关-----------//
        list: [],
        currentPage: 1,
        totoalPage: 0,
        returnServerToday: null,     //服务端返回的今天日期
        //老师资料
        teacherInfo: {},
        newShow: false,
        classType: 0,
        time: new Date(),
        //--------修改时间提示----------//
        changetimeShow: false,
      }
    },
    methods: {
      isSameDay(one, two) {
        return isSameDay(one, two);
      },
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      changeTab(num) {
        this.list = [];
        this.index = num;
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      getDay(e) {
        this.time = e;
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      changeToday() {
        this.time = new Date();
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      computeDayTime(date) {
        let month = "0" + (date.getMonth() + 1);
        let day = "0" + date.getDate();
        return date.getFullYear() + '-' + month.substring(month.length - 2) + '-' + day.substring(day.length - 2);
      },
      //根据用户选择的选项，计算XHR请求的参数
      conputeXHRParams(pageNumber) {
        //根据当前时间获得"XXXX-XX-XX"的事件格式
        let date = this.computeDayTime(this.time);
        let params = {
          c: 'ClassSchedule',
          a: 'QueryOnedayClassSchedule',
          id: this.id,                //sessionid
          isstudent: 1,
          date: date,
          pageno: pageNumber,
        };
        //对应后台，1位试听课，0位收费课
        if (this.index == '1') {
          params.democlass = 1;
        } else if (this.index == '0') {
          params.democlass = 0;
        }
        return params;
      },
      loadList(params) {
        this.list = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            if (!this.returnServerToday) {
              this.returnServerToday = response.date;
            }
            let list = response.list;
            for (let i = 0; i < list.length; i++) {
              list[i].show = false;
              list[i].coursewarelist = null;
            }
            this.list = list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //联系老师
      QueryTeacherContactInfo(item) {
        let rid = item.rid;
        let lessonid = item.lessonid;
        this.classType = item.democlass;
        this.teacherInfo = {};
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'user',
            a: 'QueryTeacherContactInfo',
            id: this.id,
            lessonid: lessonid,
            rid: rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.teacherInfo = response;
            this.newShow = true;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //获取课件
      getCourseWare(item) {
        if (item.show === false) {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'ClassCourseWare',
              a: 'QueryClassCourseWare',
              id: this.id,
              classcatalogid: item.catalogid,
              pageno: 1,
              pagesize: 200,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 111) {
              this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
            }
            if (response.code === 200) {
              item.coursewarelist = response.list;
//              Vue.set(item, coursewarelist, response.list);
              this.$forceUpdate();
            }
          }).catch((err) => {
            this.$alert('未获取到数据，请重新加载页面', '提示', {
              confirmButtonText: '刷新',
              callback: action => {
                window.location.reload();
              }
            });
          });
        }
        item.show = !item.show;
      },
      //-------------------回顾直播---------------------------//
      reviewLive(item) {
        let id = this.id;
        let classid = item.classid;
        let rid = item.rid;
        let lessonid = item.lessonid;
        let catalogindex = item.catalog_index;
        let catalogid = item.catalogid;
        window.open(`${this.GLOBAL.liveUrl}/review.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
      },
      //-------------------进入直播间---------------------------//
      gotoLive(item) {
        if (this.isSameDay(this.returnServerToday, item.planstarttime.substring(0, 10))) {
          let id = this.id;
          let classid = item.classid;
          let rid = item.rid;
          let lessonid = item.lessonid;
          let catalogindex = item.catalog_index;
          let catalogid = item.catalogid;
          window.open(`${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
        } else {
          this.changetimeShow = true;
        }
      },
      computeUrl(url) {
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      //预览课件和分享课件(预览和分享是同一个功能)
      previewWare(item) {
        window.open(`${this.GLOBAL.playUrl}v/${item.code}`);
      },
    },
    computed: {
      computeChoseDay() {
        let month = this.time.getMonth() + 1;
        let day = this.time.getDate();
        let weeks = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        let weekday = weeks[this.time.getDay()];
        return `${month}月${day}日 ${weekday}`
      },
    },
    created() {
      let params = this.conputeXHRParams(1);
      this.loadList(params);
    },
    components: {
      MyStudyNav,
      calendar,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .schedule
    margin: 10px auto 40px
    width: 1226px
    min-height: calc(100vh - 385px)
    box-sizing border-box
    overflow: hidden
    .content-right
      float: right
      width: 966px
      .top-title {
        height: 68px
        line-height: 68px;
        padding-left: 20px;
        font-size: 24px;
        font-weight: bold
        color: #333;
        background: #fff;
      }
      .category-wrapper
        height: 45px
        padding-left: 40px
        background: #ffffff
        border-top: 1px solid #f5f5f5
        .tab-item
          margin-right: 80px
          float: left
          height: 45px
          line-height: 45px
          font-size: 18px
          color: #666666
          box-sizing: border-box
          cursor: pointer
          &.active
            color: #ff6700
            border-bottom: 2px solid #ff6700
      .calendar-wrapper
        margin-top: 10px
      .list-wrapper
        margin-top: 10px
        .list-title
          height: 68px
          line-height: 68px
          padding-left: 41px
          font-size: 20px;
          color: #333333
          font-weight: bold
          background: #fff url('./deco-title.png') no-repeat left 20px center / 6px 25px
        .list-item
          margin-top: 10px
          background: #fff
          &::first-child
            margin-top: 0
          .item-top
            height: 132px
            position: relative
            .time-wrapper
              float: left
              margin: 41px 22px 0 20px
              .starttime
                font-size: 20px;
                color: #333333
                font-weight: bold
                height: 28px;
              .endtime
                font-size: 16px;
                color: #666666
                font-weight: bold
                height: 22px
            .item-img-wrapper
              float: left
              margin-top: 20px
              margin-right: 15px
              position: relative
              .item-img-icon {
                position: absolute
                left: 0
                top: 0
                display: inline-block
                width: 64px
                height: 26px
                line-height: 26px
                text-align: center
                font-size: 14px
                color: #ffffff
                background: rgba(0, 0, 0, 0.5)
              }
            .class-content-wrapper
              float: left
              .main-title
                padding-top: 39px
                height: 25px
                line-height: 25px
                font-size: 18px
                color: #333
                .connect {
                  display: inline-block
                  margin-left: 10px
                  height: 24px
                  line-height: 24px
                  text-align: center
                  width: 74px
                  border: 1px solid #ff6700
                  font-size: 14px
                  color: #ff6700
                  box-sizing: border-box
                  border-radius: 12px
                  cursor: pointer
                }
              .sub-title {
                margin-top: 10px
                height: 20px
                line-height: 20px
                font-size: 14px
                color: #888
              }
            .finish-icon {
              position: absolute
              display: inline-block
              right: 20px
              top: 36px
              width: 78px
              height: 60px
              background: url('./finish.png') no-repeat center / 78px 60px

            }
          .item-bottom
            clear: both
            .mulu-item
              border-top: 1px solid #e9e9e9
              height: 72px
              position: relative
              .place {
                float: left
                height: 72px
                .free-icon {
                  margin: 25px 0 0 20px
                  display: inline-block
                  width: 50px
                  height: 30px
                  text-align: center
                  line-height: 30px
                  font-size: 16px;
                  border-radius: 15px
                  background: #ff6700
                  color: #fff
                }
              }
              .mulu-name-wrapper
                float: left
                height: 40px
                padding: 20px 0 20px 20px
                .mulu-name
                  line-height: 40px
                  font-size: 16px
                  color: #333
              .mulu-operate-wrapper
                float: right
                margin: 20px 30px 0 0
                height: 32px
                .mulu-btn
                  display: inline-block
                  width: 100px
                  height: 32px
                  line-height: 32px
                  font-size: 16px
                  color: #fff
                  margin-right: 20px
                  border-radius: 4px
                  box-sizing: border-box
                  &:last-child
                    margin: 0
                .check {
                  border: 1px solid #e9e9e9
                  color: #333
                  text-align: left
                  text-indent: 12px
                  &.show {
                    background: url('./up.png') no-repeat right 6px center / 14px 14px
                  }
                  &.not-show {
                    background: url('./down.png') no-repeat right 6px center / 14px 14px
                  }
                }
                .review {
                  background: #d9a60d
                }
                .live {
                  background: #ff6700
                }

            .wareList-wrapper
              background: #fff
              .ware-item
                height: 80px
                background: #ffffff
                border-top: 1px solid #f5f5f5
                .ware-img-wrapper
                  float: left
                  width: 84px
                  height: 60px
                  margin: 10px 30px 0 10px
                .courseware-name
                  float: left
                  line-height: 80px
                  font-size: 16px
                  color: #333
                .courseware-btn-wrapper
                  float: right
                  margin: 24px 30px 0 0
                  height: 32px
                  .courseware-btn
                    display: inline-block
                    width: 100px
                    height: 32px
                    line-height: 32px
                    font-size: 16px
                    color: #fff
                    background: #ff6700
                    border-radius: 16px
                    box-sizing: border-box
              .no-schedule-wrapper
                height: 80px
                border-top: 1px solid #f5f5f5
                .empty-img {
                  float: left
                  margin: 6px 14px 0 390px
                }
                .no-schedule {
                  font-size: 16px
                  color: #cccccc
                  line-height: 80px
                }
        .no-result {
          padding-top: 50px
          height: 348px
          text-align: center
          box-sizing border-box
          font-size: 0
          background: #fff
          .noresult-link {
            display: block
            margin-top: 10px
            font-size: 18px
            color: #a5a5a5
          }
        }
    .newpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .newpop
        margin: auto
        padding: 30px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .new-title
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .row
          padding-left: 15px
          display: block
          height: 30px
          line-height: 30px
          font-size: 18px
          color: #000
          width: 300px

    .chantime-mask {
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .chantime {
        margin: auto
        height: 416px
        width: 460px
        padding: 30px 36px 45px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .img-wrapper {
          margin-bottom: 25px
          text-align: center
        }
        .chantime-title {
          text-align: center
          font-size: 20px
          color: #333333
          font-weight: bold
          height: 28px
          line-height: 28px
        }
        .changetime-para {
          margin: 15px 0 35px
          font-size: 16px
          color: #666666
          line-height: 24px
        }
        .changetime-btn {
          display: block
          margin: 0 auto
          width: 260px
          height: 40px
          line-height: 40px
          font-size: 16px
          color: #fff
          background: #ff6700
          border-radius: 4px
        }

      }
    }
</style>



// WEBPACK FOOTER //
// src/page/account/personal/schedule/Schedule.vue